import gql from 'graphql-tag';

import client from '../graphqlAPI';

const POST_ADD_VENUE_MUTATION = gql`
  mutation Post(
    $venueSlugName: String!,
    $venueName: String,
    $venueReadableName: ObjectLocalizationInput,
    $description: ObjectLocalizationInput,
    $image: ObjectLocalizationInput,
    $postUri: String,
    $address: String,
    $location: String,
    $country: String,
    $phone: String,
    $latitude: Float,
    $longitude: Float,
    $capacity: Int,
    ) {
    postAddVenue(
      venueSlugName: $venueSlugName,
      venueName: $venueName,
      venueReadableName: $venueReadableName,
      description: $description,
      image: $image,
      postUri: $postUri,
      address: $address,
      location: $location,
      country: $country,
      phone: $phone,
      latitude: $latitude,
      longitude: $longitude,
      capacity: $capacity,
      ) {
      isAuth
      isAdded
      venueSlugName
    }
  }
`;

const postAddVenue = async ({
  venueSlugName,
  venueName,
  venueReadableName,
  description,
  image,
  postUri,
  address,
  location,
  country,
  phone,
  latitude,
  longitude,
  capacity,
}) => {
  try {
    const result = await client.mutate({
      mutation: POST_ADD_VENUE_MUTATION,
      variables: {
        venueSlugName,
        venueName,
        venueReadableName,
        description,
        image,
        postUri,
        address,
        location,
        country,
        phone,
        latitude,
        longitude,
        capacity,
      },
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { postAddVenue: postAddVenueValidationData } } = result;

    if (postAddVenueValidationData) {
      return postAddVenueValidationData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: postAddVenueValidationData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: postAddVenue Error: ${error}`);
    return null;
  }
};

export default postAddVenue;
